import { orgAPI } from "@/api/api";
import { IntegrationConnection } from "@cohesive/api-client";
import type { Entity } from "@cohesive/api-entities";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

export function useAsanaMCPWorkspaces(
  connection: IntegrationConnection,
  options?: Partial<UseQueryOptions<Entity[], Error>>,
) {
  return useQuery<Entity[], Error>({
    queryKey: ["asana-mcp-workspaces", connection.id],
    queryFn: async () => {
      const response = await orgAPI.toolbox.execute<Entity[]>({
        integration_connection_id: connection.id,
        action_name: "asana-mcp-list-workspaces",
        action_input: {},
      });
      return response.data;
    },
    enabled: !!connection.integration_id,
    staleTime: 1000 * 60 * 5, // 5 minutes
    ...options,
  });
}
